export default {

    PENDING_REDIRECT_REQUEST: 'PENDING_REDIRECT_REQUEST',
    SUCCESS_REDIRECT_REQUEST: 'SUCCESS_REDIRECT_REQUEST',
    FAILURE_REDIRECT_REQUEST: 'FAILURE_REDIRECT_REQUEST',
}
